module.exports = __webpack_public_path__ + "static/media/list.2ce9c24f.svg";